const emailValidator = (newValue) => {
    const emailRegex = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/);
    const inputValue = newValue.trim();
    if (!emailRegex.exec(inputValue)) {
        return 'Please enter a valid format x@x.';
    }
    return '';
}

const npnValidation = (newValue) => {
    const onlyNumberRegex = new RegExp(/^[0-9-]*$/);
    const inputValue = newValue.trim();
    if (inputValue === '') {
        return 'This is a required field.';
    }
    if (inputValue.length > 9) {
        return 'You have entered too many digits. Please recheck your NPN and reenter.';
    }
    if (!onlyNumberRegex.exec(inputValue)) {
        return 'Please enter only digits.';
    }
    return '';
};

const dateValidation = (newValue, type) => {
    const givenDate = new Date(newValue);
    const currentDate = new Date();

    if (type === 'daterange' && newValue === '') {
        return 'Enter a valid date range (mm/dd/yyyy).';
    }
    if (newValue === '') {
        return 'Enter a valid date of birth (mm/dd/yyyy).';
    }
    if (type !== 'daterange' && givenDate.getTime() > currentDate.getTime()) {
        return 'The given date is in the future.';
    }
    return '';
};

const userNameValidation = (newValue) => {
    if (newValue.trim() === '') {
        return 'This is a required field.';
    }
    return '';
};

const policyNumberValidation = (newValue) => {
    const inputValue = newValue.trim();
    const allowedCharacters = /^[0-9-]*$/;  
    if ((inputValue.length > 0 && inputValue.length < 9) || inputValue.length > 10 || !allowedCharacters.test(inputValue))  {
        return 'Please enter a valid quote or policy number.';
    }
    return '';
};

const zipCodeValidation = (newValue) => {
    const inputValue = newValue.trim();
    const allowedCharacters = /^[0-9-]*$/;  
    if ((inputValue.length > 0 && inputValue.length < 5) || inputValue.length > 5 || !allowedCharacters.test(inputValue))  {
        return 'Please enter a valid ZIP code';
    }
    return '';
};

const handleFormInputChange = (event, setFormValues) => {
    const { id, value } = event.target;
    setFormValues((prevFormValues) => ({
        ...prevFormValues,
        [id]: value,
    }));
};
  
const handleFormValidation = (event, setErrors, validationCheck, type) => {
    const { id, value } = event.target;
    setErrors((prevFormErrors) => ({
        ...prevFormErrors,
        [id]: validationCheck(id, value, type),
    }));
};

const clearFormInput = (defaultValues, setFormValues) => {
    setFormValues(defaultValues || {});
};

const hasErrors = (formErrors) => {
  return Object.entries(formErrors)
    .filter(([key]) => key !== 'notFound') // exclude this key
    .some(([, value]) =>
        value !== undefined &&
        value !== null &&
        String(value).trim() !== ''
    );
};

export { emailValidator, npnValidation, dateValidation, userNameValidation, policyNumberValidation, zipCodeValidation, handleFormInputChange, handleFormValidation, clearFormInput, hasErrors };
